import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

import { generateUuid } from 'shared/utils/uuid';

export function setRequestIdInterceptor(
  instance: AxiosInstance,
  callback?: () => string,
) {
  const getRequestId = callback ?? generateUuid;

  instance.interceptors.request.use(config => {
    config.headers['X-Request-ID'] = getRequestId();

    return config;
  });
}

export function forceJsonHeaders(config: InternalAxiosRequestConfig) {
  if (!config.headers.Accept) {
    config.headers.Accept = 'application/json';
  }

  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
}

export function forceCSRFToken(config: InternalAxiosRequestConfig) {
  const csrftoken = Cookies.get('csrftoken');
  if (csrftoken) {
    config.headers['X-CSRFToken'] = csrftoken;
  }
}
